import React, {SVGAttributes} from 'react'

const Link: React.FC<SVGAttributes<SVGElement>> = (props) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path d="M14.725 7.234l-2.997 2.996a4.236 4.236 0 0 1-5.992 0 4.233 4.233 0 0 1-.644-.854l1.393-1.393c.066-.067.148-.105.226-.15.096.329.264.64.523.9a2.12 2.12 0 0 0 2.996 0l2.996-2.997a2.12 2.12 0 0 0 0-2.997 2.121 2.121 0 0 0-2.996 0L9.165 3.806a5.316 5.316 0 0 0-2.703-.294l2.27-2.27a4.238 4.238 0 0 1 5.993 5.992zm-7.923 4.927l-1.066 1.066a2.122 2.122 0 0 1-2.997 0 2.122 2.122 0 0 1 0-2.997l2.997-2.996a2.12 2.12 0 0 1 2.996 0c.258.258.426.57.524.898.078-.046.159-.083.225-.149l1.393-1.392a4.165 4.165 0 0 0-.644-.855 4.237 4.237 0 0 0-5.993 0L1.241 8.732a4.238 4.238 0 0 0 5.993 5.993l2.271-2.27a5.313 5.313 0 0 1-2.703-.294z" />
  </svg>
)

export default Link
